// extracted by mini-css-extract-plugin
module.exports = {"root":"EditbleItem_root__1C3sx","rightBlock":"EditbleItem_rightBlock__xLsub","name":"EditbleItem_name__XnC13"};